import './main.scss';
import Headroom from "headroom.js";

window.cream = window.cream || {};

cream.init = function() {

  cream.navigation();
  cream.productFilter();
  cream.updateCart();
  cream.sticky_cart_collateral();

};



// ------------------------------------------------------------
// Get current CSS breakpoint
// ------------------------------------------------------------

const breakpoint = {};
breakpoint.refreshValue = function() {
  this.value = window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content').replace(/\"/g, '');
};



(function($) {

  $(document).ready(function(){
    console.log('=== DOCUMENT READY - DOM STATE CHECK ===');
    console.log('Cart count elements found:', $('.cart-contents .count').length);
    console.log('Widget cart content elements found:', $('div.widget_shopping_cart_content').length);
    console.log('Current cart count:', $('.cart-contents .count').html());
    console.log('Current widget cart content length:', $('div.widget_shopping_cart_content').html()?.length || 'N/A');

    $('input#username, input#reg_email').attr('placeholder', 'E-mailadres');
    $('input#password, input#reg_password ').attr('placeholder', 'Wachtwoord');
    $('#user_email').attr('placeholder', 'User Email');
    $('.woocommerce-ResetPassword input#user_login').attr('placeholder', 'E-mailadres');
  });


  /**
	 * Get total cart content via datalayer
	 * ------------------------------------------------ */
  //var cartContents = dataLayer[0]['cartContent']['totals']['total'] * 1.21;


  /**
	 * Open search form
	 * ------------------------------------------------ */
  // var searchButton = $('.js-search-button');
  // var searchForm = $('.site-header__search');

  // searchButton.click(function(e) {
	// 	e.preventDefault();
	// 	searchForm.toggleClass("is-active");
	// });

  /**
	 * Activate Klaviyo checkbox
	 * ------------------------------------------------ */
  //$("#kl_newsletter_checkbox").prop("checked", true);


  /**
	 * Coupon reveal
	 * ------------------------------------------------ */

  const input = document.querySelector('#coupon_code_input');
  const button = document.querySelector('#coupon_code_button');

  if (input) {
    input.addEventListener('input', evt => {
      const value = input.value;

      if (!value) {
        input.dataset.state = '';
        return;
      }

      const trimmed = value.trim();

      if (trimmed) {
        //input.dataset.state = 'valid';
        button.style.display = 'block';
      } else {
        //input.dataset.state = 'invalid';
        button.style.display = 'none';
      }
    });
  };

  /**
   * Form labels
   * ------------------------------------------------ */

  let show = 'has-visible-label'
  let input_field = $('form.checkout input');

  input_field.on('checkval', function () {
      let label = $(this).parents('.form-row');

      if(this.value !== '') {
          label.addClass(show);
      } else {
          label.removeClass(show);
      }
  }).on('keyup', function () {
      $(this).trigger('checkval');
  });

  $(document).ready(function() {
      input_field.each(function () {
          if($(this).val() == '') {
              $(this).parents('.form-row').removeClass(show);
          } else {
              $(this).parents('.form-row').addClass(show);
          }
      });

      let login =  $('.woocommerce-account-fields');
      $('#billing_email_field').append(login);
  });



	/**
	 * Slider
	 * ------------------------------------------------ */
  $('.reviews-gallery').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		wrapAround: true,
		pageDots: false,
		prevNextButtons: false,
    autoPlay: true

	});


  $('.product-grid-gallery .products').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		wrapAround: false,
		pageDots: true,
		prevNextButtons: true,
		adaptiveHeight: true,
		watchCSS: true,
		groupCells: true,
		groupCells: 2

	});

  // Iterate over each .carousel element
  $('.product-grid-gallery .products').each(function() {
    // Get the current carousel element
    var flkty = $(this);

    // Create a container element for buttons and page dots
    var controlsContainer = $('<div class="custom-controls"></div>');

    // Move the Flickity buttons and page dots into the custom container
    flkty.parent().append(controlsContainer);
    controlsContainer.append(flkty.find('.flickity-prev-next-button'));
    controlsContainer.append(flkty.find('.flickity-page-dots'));
    
  });


	/**
	 * Mobile nav toggle
	 * ------------------------------------------------ */

	var sidemenu_active = false;
	$('.site-nav-toggle').click(function(e) {
		e.preventDefault();
		sidemenu_active = true;
		$('body','html').addClass('overflow--noscroll');
    $('body').addClass('mobile-site-nav-is-active');
		$('.site-nav-overlay').addClass('is-active');
		$('.site-nav-mobile').addClass('is-active');
	});
	$('.site-nav-overlay, .site-nav-mobile__close').bind('touchstart click', function(){
	  if (sidemenu_active) {
		$('body','html').removeClass('overflow--noscroll');
    $('body').removeClass('mobile-site-nav-is-active');
		$('.site-nav-overlay').removeClass('is-active');
		$('.site-nav-mobile').removeClass('is-active');
	    setTimeout(function(){
		    sidemenu_active = false;
		}, 100);
	  }
	  return false
	});


	$('.side-menu__nav li.menu-item-has-children').on('click', function(e) {
		if( e.target === this ) {
			e.preventDefault();
			$('> .sub-menu',this).slideToggle(100);
			$(this).toggleClass('is-active');
		}
	});


	/**
	 * Add to cart loop button
	 * ------------------------------------------------ */

  $('.product-card .add_to_cart_button').click(function(e) {
  		e.preventDefault();

      var parent = $(this).parent();
      parent.addClass('add-to-cart-clicked');

      timeout = setTimeout(function () {
          parent.removeClass('add-to-cart-clicked');
      }, 2500);
	});


  	// ------------------------------------------------------------
	// Product Gallery
	// ------------------------------------------------------------

	var carousel = $('.gallery-main').flickity({
		cellAlign: 'left',
	  	contain: true,
		wrapAround: true,
	});

	var carouselNav = $('.gallery-thumbs');
	var carouselNavCells = carouselNav.find('.gallery-thumbs__item');

	carouselNav.on( 'click', '.gallery-thumbs__item', function( event ) {
	  var index = $( event.currentTarget ).index();
	  carousel.flickity( 'select', index );
	});

	var flkty = carousel.data('flickity');
	//var navTop  = carouselNav.position().top;
	var navCellHeight = carouselNavCells.height();
	var navHeight = carouselNav.height();

	carousel.on( 'select.flickity', function() {
	  // set selected nav cell
	  carouselNav.find('.is-selected').removeClass('is-selected');
	  var selected = carouselNavCells.eq( flkty.selectedIndex ).addClass('is-selected');

		// scroll nav
	  var scrollY = selected.position().top + carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;
	  carouselNav.animate({
	    scrollTop: scrollY
	  });
	});


	// ------------------------------------------------------------
	// Product review slider
	// ------------------------------------------------------------

	var reviewForm = $('#review_form');
	var reviewButton = $('#review_intro .button');

	reviewForm.hide();

	reviewButton.click(function(e) {
		e.preventDefault();
		reviewForm.slideToggle("slide");
	});


// ------------------------------------------------------------
// Activate ajax add to cart on single product pages
// From: https://aceplugins.com/ajax-add-to-cart-button-on-the-product-page-woocommerce/
// ------------------------------------------------------------

  $('form.cart').on('submit', function(e) {
		e.preventDefault();
		console.log('=== CART FORM SUBMIT STARTED ===');

		var form = $(this);
		form.block({ message: null, overlayCSS: { background: '#f6f6f6', opacity: 0.6 } });

		var formData = new FormData(form[0]);
		formData.append('add-to-cart', form.find('[name=add-to-cart]').val() );

		console.log('Form data prepared:', {
			'add-to-cart': form.find('[name=add-to-cart]').val(),
			'form': form[0]
		});

		// Ajax action.
		$.ajax({
			url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'ace_add_to_cart' ),
			data: formData,
			type: 'POST',
			processData: false,
			contentType: false,
			beforeSend: function() {
				console.log('AJAX request started to:', wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'ace_add_to_cart' ));
			},
			complete: function( response ) {
				console.log('=== AJAX COMPLETE CALLBACK STARTED ===');
				console.log('Raw AJAX response:', response);
				
				response = response.responseJSON;
				console.log('Parsed JSON response:', response);

				if ( ! response ) {
					console.log('❌ No response received');
					form.unblock();
					return;
				}

				if ( response.error && response.product_url ) {
					console.log('❌ Redirecting due to error:', response.error);
					window.location = response.product_url;
					return;
				}

				// Redirect to cart option
				if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
					console.log('🔄 Redirecting to cart page');
					window.location = wc_add_to_cart_params.cart_url;
					return;
				}

				//var $thisbutton = form.find('.single_add_to_cart_button'); //
				var $thisbutton = null; // uncomment this if you don't want the 'View cart' button

				// Check current DOM state BEFORE updating
				console.log('=== DOM STATE BEFORE UPDATE ===');
				console.log('Cart count element exists:', $('.cart-contents .count').length > 0);
				console.log('Current cart count content:', $('.cart-contents .count').html());
				console.log('Widget cart content exists:', $('div.widget_shopping_cart_content').length > 0);
				console.log('Current widget content length:', $('div.widget_shopping_cart_content').html()?.length || 'N/A');

				// Update fragments manually
				if ( response.fragments ) {
					console.log('✅ Fragments received:', Object.keys(response.fragments));
					console.log('Full fragments object:', response.fragments);
					
					$.each( response.fragments, function( key, value ) {
						console.log('--- Processing fragment ---');
						console.log('Fragment key:', key);
						console.log('Fragment value (first 200 chars):', value.substring(0, 200) + '...');
						console.log('Elements matching selector:', $(key).length);
						
						if ($(key).length === 0) {
							console.log('⚠️  No elements found for selector:', key);
						} else {
							console.log('✅ Found', $(key).length, 'elements for selector:', key);
							console.log('Element HTML before update (first 100 chars):', $(key).html()?.substring(0, 100) + '...');
							
							$( key ).replaceWith( value );
							
							// Check if update worked
							setTimeout(function() {
								console.log('Element HTML after update (first 100 chars):', $(key).html()?.substring(0, 100) + '...');
							}, 100);
						}
					} );
					
					console.log('✅ All fragments processed');
				} else {
					console.log('❌ No fragments received in response');
				}

				// Check DOM state AFTER updating
				setTimeout(function() {
					console.log('=== DOM STATE AFTER UPDATE ===');
					console.log('Cart count element exists:', $('.cart-contents .count').length > 0);
					console.log('Updated cart count content:', $('.cart-contents .count').html());
					console.log('Widget cart content exists:', $('div.widget_shopping_cart_content').length > 0);
					console.log('Updated widget content length:', $('div.widget_shopping_cart_content').html()?.length || 'N/A');
				}, 200);

				// Trigger event so themes can refresh other areas.
				console.log('🎯 Triggering added_to_cart event with:', {
					fragments: response.fragments ? Object.keys(response.fragments) : 'none',
					cart_hash: response.cart_hash,
					button: $thisbutton
				});
				$( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $thisbutton ] );

				// Remove existing notices
				$( '.woocommerce-error, .woocommerce-message, .woocommerce-info' ).remove();
				
				// Add new notices
				if ( response.fragments && response.fragments.notices_html ) {
					form.closest('.product').before(response.fragments.notices_html);
					console.log('✅ Notice added successfully');
				} else {
					console.log('⚠️  No notices to add');
				}

				form.unblock();
				console.log('=== AJAX COMPLETE CALLBACK FINISHED ===');
			},
			error: function(xhr, status, error) {
				console.log('❌ AJAX ERROR:', {
					status: status,
					error: error,
					response: xhr.responseText
				});
				form.unblock();
			}
		});
	});



})( jQuery );


// ------------------------------------------------------------
// Update cart
// ------------------------------------------------------------

cream.updateCart = function($) {

    var timeout;

    $('.woocommerce').on('change', '.quantity select', function(){
        if ( timeout !== undefined ) {
            clearTimeout( timeout );
        }

        timeout = setTimeout(function() {
            $("[name='update_cart']").trigger("click");

        }, 500 ); // 1 second delay, half a second (500) seems comfortable too

        // Change sticky cart totals

    });

    // Copy total price
    function copyTotalPrice() {
      var html = $('.cart_totals .order-total .woocommerce-Price-amount').html();
      $('.js-cart_totals').empty().append(html);
    }

    copyTotalPrice()

    $(document.body).on('updated_cart_totals', function () {
      copyTotalPrice()
    });


}( jQuery );


// ------------------------------------------------------------
// Filter
// ------------------------------------------------------------

cream.productFilter = function($) {

  var sidemenu_active = false;
	$('.filter-bar__filter').click(function(e) {
		e.preventDefault();
		sidemenu_active = true;
		$('body','html').addClass('overflow--noscroll');
		$('.site-nav-overlay').addClass('is-active');
		$('.product-filter').addClass('is-active');
	});

	$('.site-nav-overlay').bind('touchstart click', function(){
	  if (sidemenu_active) {
		$('body','html').removeClass('overflow--noscroll');
		$('.site-nav-overlay').removeClass('is-active');
		$('.product-filter').removeClass('is-active');
	    setTimeout(function(){
		    sidemenu_active = false;
		}, 100);
	  }
	  return false
	});


}( jQuery );


// ------------------------------------------------------------
// Navigations
// ------------------------------------------------------------

cream.navigation = function($) {

    // headroom
    const header = document.querySelector(".site-header");
    const options = {
        offset: 120,
        tolerance : {
            up : 0,
            down : 5
        },
        onUnpin : function() {
            // close search bar
            $('.site-header__search').removeClass("is-active");
        }

    }
    const headroom = new Headroom(header, options);
    headroom.init();

    $(window).ready(function() {
        if(window.location.hash) {
            $(".site-header").not('headroom--top').addClass('headroom--unpinned');
        }
    });

    // on resize
    $(window).ready(function() {
        handleNotifications(window.innerWidth);
    });
    $(window).resize(function() {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function(){
            handleNotifications(window.innerWidth);
        }, 200);
    });


    var timeout;
    var timeoutDelay = 500;

    function showOverview() {
        $('.widget_shopping_cart').removeClass('active');
        $('.site-header').addClass('active');
        $('.widget_shopping_cart').addClass('active');
        clearTimeout(timeout);
    }


    function hideOverview() {
        timeout = setTimeout(function () {
            $('.widget_shopping_cart').removeClass('active');
            $('.site-header').removeClass('active');
        }, timeoutDelay);
    }


    function handleNotifications(width) {
        $('.site-header-cart, .widget_shopping_cart').off('mouseenter', showOverview);
        $('.site-header-cart, .widget_shopping_cart').off('mouseleave', hideOverview);

        if (width > 991) {
            $('.site-header-cart').on('mouseenter', showOverview);
            $('.site-header-cart').on('mouseleave', hideOverview);
        }
    }


    // Show overview on added to cart
    $(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
      console.log('🎯 added_to_cart event received with:', {
        fragments: fragments ? Object.keys(fragments) : 'none',
        cart_hash: cart_hash,
        button: $button
      });
      
      showOverview();
      timeout = setTimeout(function () {
        $('.widget_shopping_cart').removeClass('active');
        $('.site-header').removeClass('active');
      }, 3000);
    });



}( jQuery );


// ------------------------------------------------------------
// Sticky cart collateral
// ------------------------------------------------------------

cream.sticky_cart_collateral = function() {

    const stickyCart = document.getElementsByClassName('sticky-cart-collaterals');
    const images = document.querySelectorAll('.cart_totals');

    var observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add('fancy');
          stickyCart[0].classList.remove('is-active')
          console.log('in view');
        } else {
          entry.target.classList.remove('fancy');
          stickyCart[0].classList.add('is-active')
          console.log('not in view');
        }
      });
    });

    images.forEach(image => {
      observer.observe(image);
    });

}();



// ------------------------------------------------------------
// Collapsable blocks
// ------------------------------------------------------------

(function vanillaJscollapsable() {
    var collapsableButtons = document.querySelectorAll('.collapsable__button');
    var i = 0;
    for (i = 0; i < collapsableButtons.length; i++) {

        collapsableButtons[i].addEventListener('click', function (e) {
            var activeContent = document.querySelectorAll('.collapsable__content--active');
            var contentToDisplay = this.nextElementSibling;
            var clickedButton = e.currentTarget;

            if (clickedButton.getAttribute('aria-expanded') === 'false') {
                clickedButton.setAttribute('aria-expanded', 'true');
                clickedButton.setAttribute('title', 'Hide content');
            } else {
                clickedButton.setAttribute('aria-expanded', 'false');
                clickedButton.setAttribute('title', 'Show content');
            }

            if (contentToDisplay.classList.contains('collapsable__content--active')) {
                contentToDisplay.classList.remove('collapsable__content--active');
                contentToDisplay.setAttribute('aria-hidden', 'true');
                return;
            }

            for (var i = 0; i < activeContent.length; i++) {
                activeContent[i].classList.remove('collapsable__content--active');
                activeContent[i].setAttribute('aria-hidden', 'true');
                activeContent[i].previousElementSibling.setAttribute('aria-expanded', 'false');
                activeContent[i].previousElementSibling.setAttribute('title', 'Show content');
            }

            contentToDisplay.classList.toggle('collapsable__content--active');
            contentToDisplay.setAttribute('aria-hidden', 'false');

        });
    }
})();


